import request from './httpService';

export const PermissionCatalogService = {
  get: (signal) => request({ method: 'GET', url: '/auth/action-catalog', signal })
};
